<template>
  <v-container fluid class="pa-0">
    <v-list three-line>
      <!-- General Info -->
      <v-list-item class="pa-0">
      
        <v-list-item-action tile class="ml-4 mr-0">
          <v-img :src="kioskPicture" :size="this.isSmallDevice ? '70' : '90'"/>
        </v-list-item-action>

        <v-list-item-content :class="this.isSmallDevice ? 'ml-3' : ''">
          <v-list-item-title class="ml-4">{{ kioskName }}</v-list-item-title>
          <v-list-item-subtitle class="ml-4">{{ kioskDescription }}</v-list-item-subtitle>
          <v-list-item-subtitle class="ml-4">{{ facility.name }}</v-list-item-subtitle>
          <v-list-item-subtitle :class="`${subtitleClass} ml-4`">{{ facility.geographicalDescription }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
import { ImageUri, KioskTypeId } from '@/config.js'
import { mapGetters } from 'vuex'

export default {
  name: 'GeneralInfo',
  data() {
    return {
      imageUri_NoAvatar: ImageUri.NoAvatar,
      imageUri_GenieKiosk: ImageUri.GenieKiosk,
      imageUri_AbbyKiosk: ImageUri.AbbyKiosk,
      kioskTypeId_Genie: KioskTypeId.Genie
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'activeKiosk']),

    isGenie () {
      return this.activeKiosk.typeId === this.kioskTypeId_Genie
    },
    kioskName () {
      const name = !this.isNullOrUndefined(this.activeKiosk)
        ? this.activeKiosk.name
        : 'unknown kiosk'
      
        return this.isAdmin && this.kioskId !== null
          ? `${name} (${this.kioskId})`
          : name
    },
    kioskDescription () {
      return !this.isNullOrUndefined(this.activeKiosk)
        ? this.activeKiosk.description
        : null
    },
    facility () {
      const unknownFacility = {
        id: 0,
        name: 'Unknown Facility',
        code: 'UNKNOWN'
      }
      if (this.isNullOrUndefined(this.activeKiosk)) return unknownFacility
      return this.activeKiosk.facility
    },
    kioskId () {
      if (this.activeKiosk === null) return null
      return this.activeKiosk.id
    },
    kioskPicture () {
      return this.isGenie
          ? this.imageUri_GenieKiosk
          : this.imageUri_AbbyKiosk
    },

    // classes
    subtitleClass () {
      return 'grey--text lighten-2 font-weight-light'
    }
  }
}
</script>

<style scoped>
.v-card__text {
  padding: 0 !important;
}
</style>
